import {
  IconBuildingBank,
  IconCreditCard,
  IconTrendingUp,
  IconCheckbox,
  IconApps,
  IconDotsCircleHorizontal,
  IconShieldCheck,
  IconMoneybag,
} from "@tabler/icons";

const categories = [
  {
    label: "Bank Account",
    href: "/products/categories/bank",
    icon: (
      <IconBuildingBank
        style={{
          width: "30px",
          height: "30px",
        }}
      />
    ),
  },
  {
    label: "Credit card",
    href: "/products/categories/credit",
    icon: (
      <IconCreditCard
        style={{
          width: "30px",
          height: "30px",
        }}
      />
    ),
  },
  {
    label: "Demat Account",
    href: "/products/categories/demat",
    icon: (
      <IconTrendingUp
        style={{
          width: "30px",
          height: "30px",
        }}
      />
    ),
  },
  {
    label: "Pay Later",
    href: "/products/categories/pay",
    icon: (
      <IconCheckbox
        style={{
          width: "30px",
          height: "30px",
        }}
      />
    ),
  },
  {
    label: "Insurance",
    href: "/products/categories/insurance",
    icon: (
      <IconShieldCheck
        style={{
          width: "30px",
          height: "30px",
        }}
      />
    ),
  },
  {
    label: "Loan",
    href: "/products/categories/loan",
    icon: (
      <IconMoneybag
        style={{
          width: "30px",
          height: "30px",
        }}
      />
    ),
  },
  {
    label: "Others",
    href: "/products/categories/others",
    icon: (
      <IconApps
        style={{
          width: "30px",
          height: "30px",
        }}
      />
    ),
  },
];

export default categories;
